import { serializeFieldValue as e } from "./dateValue.js";
import { forwardRef as t } from "react";
import { jsx as n } from "react/jsx-runtime";
//#region lib/components/DatePicker/HiddenDateInput.tsx
var r = t(function({ name: t, value: r, format: i, timeZone: a, required: o }, s) {
	return /* @__PURE__ */ n("input", {
		ref: s,
		type: "hidden",
		name: t,
		value: e(r, i, a),
		required: o,
		tabIndex: -1,
		"aria-hidden": !0
	});
});
//#endregion
export { r as HiddenDateInput };
